(function () {
  var menuBtn = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', function () {
      mobileNav.classList.toggle('is-open');
    });
  }

  var searchBtn = document.querySelector('[data-search-toggle]');
  var searchBar = document.querySelector('[data-search-bar]');
  if (searchBtn && searchBar) {
    searchBtn.addEventListener('click', function () {
      searchBar.classList.toggle('is-open');
      var input = searchBar.querySelector('input[type="search"]');
      if (input && searchBar.classList.contains('is-open')) input.focus();
    });
  }

  // Product gallery
  var mainImg = document.querySelector('[data-main-image]');
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!mainImg) return;
      mainImg.src = thumb.getAttribute('data-full');
      document.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  // Variant selection
  var form = document.querySelector('form[action*="/cart/add"]');
  if (form) {
    var variantData = JSON.parse(document.getElementById('VariantData').textContent || '[]');
    var selects = form.querySelectorAll('[data-option-index]');
    var idInput = form.querySelector('[name="id"]');
    var submit = form.querySelector('[data-add-button]');
    var priceEl = document.querySelector('[data-variant-price]');

    function update() {
      var chosen = [];
      selects.forEach(function (s) { chosen.push(s.value); });
      var match = variantData.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) priceEl.innerHTML = match.price_html;
      if (match.available) {
        submit.removeAttribute('disabled');
        submit.textContent = 'Add to bag';
      } else {
        submit.setAttribute('disabled', 'disabled');
        submit.textContent = 'Sold out';
      }
      if (match.featured_image && mainImg) mainImg.src = match.featured_image;
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
  }

  // Quantity steppers
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = b.getAttribute('data-step') === 'up' ? 1 : -1;
        var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = next;
        if (input.form && input.hasAttribute('data-auto-submit')) input.form.submit();
      });
    });
  });
})();
